export const FilesTableColumns = [
    { text: 'Tên tệp tin', icon: <></> },
    { text: 'Mã đơn hàng sản xuất/vật liệu', icon: <></> },
    { text: 'Ngày tải lên', icon: <></> },
    { text: 'Khách hàng', icon: <></> },
    { text: 'Tải lên bởi', icon: <></> },
    { text: '', icon: <></> },
];
